import { PractitionerType } from "cmw-client";

export const PRACTITIONER_TYPE_LABELS: Record<PractitionerType, string> = {
  [PractitionerType.Psychologist]: "Psychologist",
  [PractitionerType.Psychiatrist]: "Psychiatrist",
  [PractitionerType.Counsellor]: "Counsellor",
  [PractitionerType.SocialWorker]: "Social Worker",
  [PractitionerType.ArtTherapist]: "Art Therapist",
};

export const formatDistance = (metres: number): string => {
  const km = metres / 1000;
  return `${km < 10 ? km.toFixed(1) : Math.round(km)} km away`;
};
